export default {
  title: "Vouchers",
  subtitle: "Manage discount vouchers and promotions",
  
  addNew: "Create New Voucher",
  createVoucher: "Create Voucher",
  editVoucher: "Edit Voucher",
  deleteVoucher: "Delete Voucher",
  
  fields: {
    code: "Voucher Code",
    name: "Voucher Name",
    description: "Description",
    type: "Discount Type",
    value: "Discount Value",
    minOrderAmount: "Minimum Order Amount",
    maxDiscountAmount: "Maximum Discount Amount",
    usageLimit: "Usage Limit",
    usageCount: "Times Used",
    startDate: "Start Date",
    endDate: "End Date",
    isActive: "Active",
    isPublic: "Public",
    autoApply: "Auto Apply",
    maxAmount: "Max Discount Amount",
    maxAmountHint: "-1 means unlimited",
    applicableProducts: "Applicable Products",
    applicableCategories: "Applicable Categories",
    status: "Status",
    createdAt: "Created At",
    updatedAt: "Updated At"
  },
  
  placeholders: {
    code: "Enter voucher code (e.g., SAVE20)",
    name: "Enter voucher name",
    description: "Enter voucher description",
    value: "Enter discount value",
    minOrderAmount: "Enter minimum order amount",
    maxDiscountAmount: "Enter maximum discount amount",
    usageLimit: "Enter usage limit (0 for unlimited)",
    maxAmount: "Enter max discount amount (-1 for unlimited)",
    startDate: "Select start date",
    endDate: "Select end date"
  },
  
  messages: {
    createSuccess: "Voucher created successfully",
    createError: "Failed to create voucher",
    updateSuccess: "Voucher updated successfully",
    updateError: "Failed to update voucher",
    deleteSuccess: "Voucher deleted successfully",
    deleteError: "Failed to delete voucher",
    deleteConfirm: "Are you sure you want to delete this voucher?",
    noVouchers: "No vouchers found",
    loadingVouchers: "Loading vouchers...",
    fetchError: "Failed to fetch vouchers",
    fetchCustomersError: "Failed to fetch customers",
    codeExists: "Voucher code already exists",
    expired: "This voucher has expired",
    notStarted: "This voucher is not yet active",
    limitReached: "Usage limit reached for this voucher"
  },
  
  validation: {
    codeRequired: "Voucher code is required",
    codeMinLength: "Voucher code must be at least 3 characters",
    codeMaxLength: "Voucher code must not exceed 20 characters",
    nameRequired: "Voucher name is required",
    typeRequired: "Discount type is required",
    valueRequired: "Voucher value is required",
    fromRequired: "Start date is required",
    toRequired: "End date is required",
    numberOfUseRequired: "Number of uses is required",
    fillAllFields: "Please fill in all required fields",
    valueMin: "Discount value must be greater than 0",
    startDateRequired: "Start date is required",
    endDateRequired: "End date is required",
    endDateAfterStart: "End date must be after start date",
    minOrderAmountMin: "Minimum order amount must be 0 or greater",
    usageLimitMin: "Usage limit must be 0 or greater"
  },
  
  table: {
    select: "Select",
    code: "Code",
    couponType: "Coupon Type",
    value: "Value",
    numberOfUse: "Number Of Use",
    maxAmount: "Max Amount",
    from: "From",
    to: "To",
    isActive: "Is Active",
    isPublic: "Is Public",
    isUsed: "Is Used",
    customers: "Customers",
    actions: "Actions"
  },
  
  types: {
    percent: "Percent",
    amount: "Amount"
  },

  actions: {
    coupons: "Coupons",
    autoRefundCoupons: "Auto Refund Coupons",
    addNewCoupon: "Add New Coupon",
    edit: "Edit",
    delete: "Delete",
    refresh: "Refresh",
    export: "Export",
    search: "Search coupons...",
    filter: "Filter"
  },

  status: {
    active: "Yes",
    inactive: "No",
    unlimited: "Unlimited"
  },

  statusOptions: {
    active: "Active",
    inactive: "Inactive",
    expired: "Expired",
    scheduled: "Scheduled"
  },
  
  breadcrumbs: {
    vouchers: "Vouchers",
    create: "Create Voucher",
    edit: "Edit Voucher",
    view: "View Voucher"
  },

  buttons: {
    submit: "Submit",
    update: "Update",
    submitting: "Submitting...",
    updating: "Updating...",
    backToIndex: "Back to Index"
  }
};
